import {useContext, useEffect, useState} from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Container} from "react-bootstrap";
import API, { HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import PracticeItem from "../components/PracticeItem";
import PracticeView from "../components/PracticeView";
import {useLocation} from "react-router-dom";
import {ExtraVideo} from "../models/ExtraVideo";
import ExtraVideoItem from "../components/ExtraVideoItem";
import ExtraVideoView from "../components/ExtraVideoView";

export default function ExtraVideos() {
    const app = useContext(AppContext)
    const [videos, setExtraVideos] = useState([])
    const { enqueueSnackbar } = useSnackbar()
    const location = useLocation()
    const initialVideo = location?.state?.initialVideo;
    const [currentVideo, setCurrentVideo] = useState(null)

    useEffect(() => {
        if(currentVideo === null)
            getExtraVideos()

    }, [currentVideo, app.user.current_course])

    const getExtraVideos = async () => {
        try {
            const res = await API({
                method: 'GET',
                url: `/extra-videos/${app.user.current_course}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            let activeVideo = null;
            let videos = res.data.items.map((jsonData, idx) => {
                let vid = new ExtraVideo(jsonData)
                if(initialVideo && initialVideo === vid.ID)
                    activeVideo = vid

                return vid
            })
            setExtraVideos(videos)
            if(activeVideo) {
                setExtraVideos(activeVideo)
            }
        }
        catch(e) {
            window.location.href = '/';
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <div id="page-extra_videos" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container fluid className="extra_video-container">
                {videos.map((video, idx) => {
                    return <ExtraVideoItem key={'practice-cat-' + idx} video={video} currentVideo={currentVideo}
                                        setCurrentVideo={setCurrentVideo} ref={null} />
                })}
            </Container>
        </div>
        {currentVideo !== null && <ExtraVideoView currentVideo={currentVideo} setCurrentVideo={setCurrentVideo} />}
    </div>
}